import { render, staticRenderFns } from "./v-alert.vue?vue&type=template&id=74fa730a&"
import script from "./v-alert.js?vue&type=script&lang=js&"
export * from "./v-alert.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports